<script setup lang="ts">
import type { ResponsiveImageType } from "vue-datocms";
import type { ImageFileField, ProductGroupDetailSectionRecord } from "~~/server/graphql/datocms/generated";
import { Image as DatocmsImage } from "vue-datocms";

defineProps<{ data: ProductGroupDetailSectionRecord }>();
</script>

<template>
  <div class="mb-3xl lg:mb-5xl md:full-bleed border-0 border-b border-neutral-100 bg-linear-to-b from-transparent to-[#EBE8E0]">
    <div class="container mx-auto">
      <div class="flex flex-col items-center">
        <h2 class="mb-lg text-center" v-html="data.title" />

        <div class="mb-xl w-full text-center lg:w-2/5" v-html="data.text" />

        <div class="my-xl gap-lg flex flex-wrap justify-center">
          <div v-for="group in data.groups" :key="group.id" class="gap-md flex w-25 flex-col items-center">
            <img :src="group.icon.url" alt="" class="size-4xl" loading="lazy">
            <span class="text-center text-sm font-bold">{{ group.name }}</span>
          </div>
        </div>

        <DatocmsImage
          v-if="data.footerImage as ImageFileField"
          :data="data.footerImage?.responsiveImage as ResponsiveImageType"
          :lazy-load="false"
          object-fit="cover"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
